export const LOYALTY_REDEEM_TEXT_KEY = 'perksReadyToUse';
